import { ObserverChange, UsersResponse } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import moment from 'moment'
import { convertObserverChangeResponse } from './shared/convert'
import keys from './shared/keys'

export function useUserChanges(companyId: string | undefined) {
  const { server } = useServer()
  const query = useQuery<ObserverChange[]>({
    queryKey: keys.changes(companyId),
    queryFn: fetchUserChanges,
    refetchOnMount: 'always',
    enabled: !!companyId,
  })

  return query

  async function fetchUserChanges() {
    if (!companyId) {
      throw new Error('Company id invalid')
    }
    const response = await server.get<UsersResponse.ObserverChangeResponse[]>(
      `/v2/users/observers/audit/${companyId}`
    )
    return response
      .flatMap(convertObserverChangeResponse)
      .sort((a, b) => moment(b.changedAt).diff(moment(a.changedAt), 'seconds'))
  }
}
